import {ServerResponse} from 'http';
import {IS_CLIENT_SIDE} from './shared/utils/constants';

interface Params {
  destination: string;
  res?: ServerResponse;
}

export function redirectInInitialProps({destination, res}: Params) {
  if (res && !IS_CLIENT_SIDE) {
    res.writeHead(302, {
      Location: destination,
    });
    res.end();
  } else {
    window.location.replace(destination);
  }
}
